export interface ShelfFile {
  id: number
  name: string
  size: number
  width: number
  height: number
  user_id: number
  mimetype: string
  url: string | null
  company_id: number
  path: string | null
  folder_id: number | null
  thumbnail: string | null
  deleted_at: string | null
  page_count: number | null
  updated_at: string | null
  created_at: string | null
  description: string | null
}

export enum ShelfFolders {
  PDFs = 'PDFs',
  Images = 'Images',
  Videos = 'Videos',
}
